
export interface SupplierProps {
    _id?: string;
    supplierName: string;
    companyName: string;
    contact: string;
    tel: SupplierNumberPhoneProps[];
    fax: SupplierNumberPhoneProps;
    address?: string;
}
export interface SupplierNumberPhoneProps {
    code: string;
    number: string;
}
export const SupplierState = {
    supplierName: "",
    companyName: "",
    contact: "",
    tel: [{
        code: "+66",
        number: ""
    },
    {
        code: "+66",
        number: ""
    }],
    fax: {
        code: "+66",
        number: ""
    },
    address: "",
}